// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-69a134c6] .show-errors-cell-renderer .btn{padding:.12rem .25rem !important;font-size:.775rem !important}", ""]);
// Exports
module.exports = exports;
